<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>运营</el-breadcrumb-item>
        <el-breadcrumb-item>群发任务</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">群发任务</h2>
        </div>
        <div class="right">
          <el-button
            class="button"
            type="primary"
            @click="handelToGoCreate"
          >添加发送任务</el-button>

        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item label="任务名称">
          <el-input
            v-model.trim="query.name_keyword"
            placeholder="输入订单编号"
            @input="fetchList(true)"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select
            v-model="query.statuses"
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.statuses"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>

    <div class="results card">
      <div class="values-header">
        <p class="title">任务列表</p>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >

          <el-table-column
            label="任务名称"
            align="center"
            prop="name"
            show-overflow-tooltip
            min-width="350"
          >
          </el-table-column>
          <el-table-column
            label="创建人"
            align="center"
            width="200"
          >
            <template slot-scope="scope">
              <div>{{scope.row.creator?scope.row.creator.nickname:'暂无'}}</div>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="定时发送"
            width="200"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ $moment(scope.row.do_time).format("YYYY.MM.DD HH:mm") }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="任务状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                size="mini"
                type="warning"
                v-if="scope.row.status==0"
              >待执行</el-tag>
              <el-tag
                size="mini"
                type="success"
                v-if="scope.row.status==1"
              >执行成功</el-tag>
              <el-tag
                size="mini"
                type="danger"
                v-if="scope.row.status==2"
              >执行失败</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="号码数量"
            align="center"
            prop="count_msg_total"
            width="120"
          >
          </el-table-column>
          <el-table-column
            label="失败号码数量"
            align="center"
            prop="count_msg_fail"
            width="120"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            align="center"
            width="200"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                :underline="false"
                @click="handelToDetail(scope.row)"
              >详情</el-link>
              <el-link
                type="primary"
                :underline="false"
                @click="fetchList"
              >刷新</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import { smsSendTasklist } from "@/api/operation";


export default {
  components: {
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      createDialog: false,
      filter: {
        statuses: [
          { label: "待执行", value: '0' },
          { label: "执行成功", value: 1 },
          { label: "执行失败", value: 2 },
        ],

      }
    };
  },
  created() {
    this.fetchList();
  },
  methods: {
    fetchList() {
      const params = Object.assign({}, this.query)
      if (params.statuses) {
        params.statuses = params.statuses.filter((v) => v).join(",");
      }
      smsSendTasklist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      if (this.query.statuses) {
        this.query.statuses = this.query.statuses.split(",");
      }
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query);
      if (params.statuses) {
        params.statuses = params.statuses.filter((v) => v).join(",");
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        });
    },
    handelToGoCreate() {
      this.$router.push('/groupmessage/create')
    },
    handelToDetail(row) {
      this.$router.push(`/groupmessage/detail?id=${row.id}&data=${JSON.stringify(row)}`)
    }
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 14px;
  margin: 0px 5px;
}
</style>
